import { FC } from 'react';

import Button from 'components/_core/Button';
import Heading from 'components/_core/Heading';
import Modal, { ModalProps } from 'components/_core/Modal';
import Text from 'components/_core/Text';

import locales from './locales';

interface DeleteModalProps extends Omit<ModalProps, 'children'> {
  onDelete: () => Promise<void>;
  isDeleting?: boolean;
}

const DeleteModal: FC<DeleteModalProps> = ({
  isDeleting,
  onClose,
  onDelete,
  ...props
}) => {
  return (
    <Modal {...props} onClose={onClose}>
      <Modal.Header borderBottom="1px solid" borderColor="grey.3" />

      <Modal.Body paddingY="space-32">
        <Heading>{locales.title}</Heading>

        <Text marginTop="space-8" variant="secondary">
          {locales.descriptionMain}
        </Text>

        <Text variant="secondary">{locales.descriptionSub}</Text>
      </Modal.Body>

      <Modal.Footer justifyContent="space-between">
        <Button
          icon="arrow-left"
          iconPosition="left"
          onClick={onClose}
          variant="inline-primary"
        >
          {locales.back}
        </Button>

        <Button
          icon="trash"
          isLoading={isDeleting}
          onClick={onDelete}
          variant="danger"
        >
          {locales.deleteLogo}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteModal;
